module.exports = __webpack_public_path__ + "0960f104df94ad3ed11e7b86085a7244.pdf";